module.exports = {
  name: 'DeviceItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    isSwitch() {
      return [23, 28].includes(this.item.ctrltype);
    },
    isLevel() {
      return [24, 26, 41].includes(this.item.ctrltype);
    },
    isThermostatFan() {
      return [32].includes(this.item.ctrltype);
    },
    isThermostatMode() {
      return [33].includes(this.item.ctrltype);
    },
    isThermostatTemperature() {
      return [34].includes(this.item.ctrltype);
    },
    controls() {
      if (this.isSwitch) return this.controlsSwitch;
      if (this.isLevel) return this.controlsLevel;
      if (this.isThermostatFan) return this.controlsThermostatFan;
      if (this.isThermostatMode) return this.controlsThermostatMode;
      if (this.isThermostatTemperature) return this.controlsThermostatTemperature;
    },
    controlsSwitch() {
      return [255, 0].map(v => ({
        key: `switch_${v}`,
        title: this.$t(`device.switch_${v}`),
        color: 'primary',
        value: v
      }));
    },
    controlsLevel() {
      return [100, 75, 50, 25, 0].map(v => ({
        key: `level_${v}`,
        title: this.$t(`device.level_${v}`),
        color: 'primary',
        value: Math.min(99, v)
      }));
    },
    controlsThermostatFan() {
      return ['fan_off', 'fan_auto_low', 'fan_low', 'fan_auto_high', 'fan_high'].map((v, i) => ({
        key: `thermostat_${v}`,
        title: this.$t(`device.${v}`),
        color: 'primary',
        value: i
      }));
    },
    controlsThermostatMode() {
      return ['mode_off', 'mode_heat', 'mode_cool', 'mode_auto'].map((v, i) => ({
        key: `thermostat_${v}`,
        title: this.$t(`device.${v}`),
        color: 'primary',
        value: i
      }));
    },
    controlsThermostatTemperature() {
      let c = [23, 24, 25, 26, 27, 28, 29, 30];
      let f = [72, 74, 76, 78, 80, 82, 84, 86];
      let u = this.item.unit == 1 ? c : f;
      let l = this.item.unit == 1 ? '°C' : '°F';
      return u.map((v, i) => ({
        key: `thermostat_${v}`,
        title: `${v}${l}`,
        color: 'primary',
        value: v
      }));
    }
  },
  methods: {
    setControl(value) {
      this.$emit('control', this.item, value);
    }
  },
  template: `
<v-card>
  <v-card-actions>
    <h3 class="ml-2">{{ $t('device.control_device') }}</h3>
    <v-spacer></v-spacer>
    <v-btn icon flat color="grey" @click="$emit('close')">
      <v-icon>close</v-icon>
    </v-btn>
  </v-card-actions>
  <v-card-actions>
    <v-layout row wrap>
      <v-flex xs12 v-for="c in controls" :key="c.key">
        <v-btn flat block large :color="c.color" @click="setControl(c.value)">{{ c.title }}</v-btn>
      </v-flex>
    </v-layout>
  </v-card-actions>
</v-card>
  `
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/luffanet-web-components/DeviceAction.js
// module id = 0thZ
// module chunks = 0